import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'
import { mediaQueries } from '../../constants/mediaQueries'

const styles = css({
	fontSize: "14px",
	fontWeight: "600",
	textTransform: "none",
	letterSpacing: "0",
	[mediaQueries.isMobile]: {
		fontSize: '14px',
	},
})

const H6 = ({ children, ...otherProps }) => {
	return <h6 {...propMerge(styles, otherProps)}>{children}</h6>
}

export default H6
